<div
  class="min-w-100"
  cdkDrag
  cdkDragRootElement=".cdk-overlay-pane"
  cdkDragHandle
>
  <div
    class="flex align-items-center justify-content-between width-100"
    matDialogTitle
  >
    <span class="text-uppercase fs-normal font-light">
      <i class="pi pi-fw pi-calendar text-primary"></i>
      {{
        "Agendamentos do dia " +
          datePipe.transform(dataDialog.agendamentos[0].data_hora, "shortDate")
      }}
    </span>
    <i
      class="pi pi-fw pi-times-circle text-red-500 cursor-pointer"
      (click)="matDialogRef.close()"
    ></i>
  </div>
  <div mat-dialog-content>
    <p-table
      [value]="dataDialog.agendamentos"
      [paginator]="true"
      [rows]="5"
      [showFirstLastIcon]="false"
      [tableStyle]="{ 'min-width': '50rem' }"
      [rowsPerPageOptions]="[5, 10, 20]"
    >
      <ng-template pTemplate="header">
        <tr>
          <th>Paciente</th>
          <th>Profissional</th>
          <th>Local</th>
          <th>Tipo</th>
          <th>Hora</th>
          <th>Status</th>
          <th *ngIf="dataDialog.showBtnDialog">Ação</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-item>
        <tr>
          <td>{{ item.nome_paciente }}</td>
          <td>{{ item.nome_profissional ?? ' - ' }}</td>
          <td>{{ item.local_agendamento.descricao }}</td>
          <td>{{ getTipo(item.tipo) }}</td>
          <td>{{ item.data_hora | date: "shortTime" }}</td>
          <td [pTooltip]="item.status.replace('_', ' ')">
            <i
              class="ml-2 pi pi-fw pi-circle-fill"
              [ngStyle]="{ color: cores[item.status].primary }"
            ></i>
          </td>
          <td *ngIf="dataDialog.showBtnDialog">
            <p-button
              icon="pi pi-fw pi-ellipsis-v"
              outlined
              rounded
              severity="primary"
              [matMenuTriggerFor]="menuActions"
              (menuOpened)="getButtons(item)"
            ></p-button>
            <mat-menu #menuActions="matMenu">
              <span
                *ngIf="buttons.length === 0"
                class="font-light fs-normal text-center"
              >
                Nenhuma ação disponível!
              </span>
              <div
                *ngIf="buttons.length !== 0"
                class="flex flex-column align-items-center justify-content-center p-2 w-max"
              >
                <button
                  pButton
                  pRipple
                  *ngFor="let button of buttons"
                  [icon]="button.icon"
                  text
                  rounded
                  class="width-100"
                  [pTooltip]="button.label"
                  [label]="button.label"
                  [severity]="button.severity"
                  (click)="
                    matDialogRef.close({ action: button.action, value: item })
                  "
                ></button>
              </div>
            </mat-menu>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
